/* @flow */
import apiRequest from 'lib/apiRequest';
import Collection from 'lib/Collection';
import Teacher from 'entities/Teacher';

class Teachers extends Collection {
  initialize() {
    this.model = Teacher;
  }

  static getTeachersForOrganizationId(organizationId, query = '') {
    return apiRequest(`/organizations/${organizationId}/teachers`, 'GET', {
      query,
    }).then(
      response => Teachers.fromJSON(response)
    );
  }
}

export default Teachers;



// WEBPACK FOOTER //
// ./src/collections/Teachers.js